import { Outlet } from "react-router-dom";
import "./Css/GameGallery.css";
import Category from "./Category";
import MenuBar from "./Menubar";
import Footer from "./Footer";
import SubCateegorySection from "./SubCateegorySection";
import MostLikedGame from "./MostLikedGame";
import PrivacyPolicy from "./PrivacyPolicy";
const Layout = () => {
  return (
    <div>
      <MenuBar />
      <div className="content">
        <Outlet />

        <SubCateegorySection />
      </div>
      <MostLikedGame />
      <Category />

      <Footer />
    </div>
  );
};
export default Layout;
